// based on rc-notification 3.2.0
import Notification from './Notification'
export default Notification



// WEBPACK FOOTER //
// ./components/vc-notification/index.js